import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { usePaypalConfig, createPaypalOrder, capturePaypalOrder } from "../lib/paypal";

// Stable reference so the buttons don't re-init on every render (perf).
const BUTTON_STYLE = { layout: "vertical", color: "gold", shape: "pill", label: "paypal", height: 46 };

export const PayPalDeposit = ({ orderId, amount, name, email, flavor, filling, servings, eventDate, onSuccess }) => {
  const paypal = usePaypalConfig();
  if (paypal.loading) {
    return <p className="text-sm text-[#787069]">Loading PayPal…</p>;
  }
  if (!paypal.options) {
    return (
      <p className="text-sm text-[#787069]">
        PayPal is not configured yet. Add your PayPal Client ID to enable on-site checkout.
      </p>
    );
  }

  return (
    <div data-testid="paypal-buttons">
      <PayPalScriptProvider options={paypal.options}>
        <PayPalButtons
          style={BUTTON_STYLE}
          createOrder={async () => {
            try {
              const res = await createPaypalOrder({ order_id: orderId, amount, name, email });
              return res.id;
            } catch (e) {
              toast.error(`Could not start PayPal checkout: ${e.message}`);
              throw e;
            }
          }}
          onApprove={async (data) => {
            try {
              const res = await capturePaypalOrder(data.orderID, {
                order_id: orderId,
                name,
                email,
                amount,
                base_flavor: flavor,
                filling,
                servings,
                event_date: eventDate,
              });
              if (res.success) {
                toast.success("PayPal deposit received — thank you!");
                onSuccess?.(res);
              } else {
                toast.error("Payment could not be completed.");
              }
            } catch (e) {
              toast.error(`Payment capture failed: ${e.message}`);
            }
          }}
          onError={(err) => {
            console.error("[PayPal] button error:", err);
            toast.error("PayPal encountered an error. Please try another method.");
          }}
        />
      </PayPalScriptProvider>
      <p className="mt-3 text-xs text-[#787069] text-center">Secured by PayPal{paypal.env === "sandbox" ? " · Sandbox test mode" : ""}</p>
    </div>
  );
};
